import { PortalDialogProps } from "@app/services/modal.service";
import Modal from "../modal/modal.component";
import { Images } from "@assets/images";

function ChangePasswordSuccessModal({ portalDialogRef }: PortalDialogProps) {
  return (
    <Modal onCancel={portalDialogRef.close} buttonCancelInChildren={false}>
      <div className="w-[516px] py-7 px-6 flex flex-col items-center">
        <img src={Images.Success.default} alt="" />
        <div className="mt-7 text-xl font-bold text-center">
          Mật khẩu của bạn đã được thay đổi
        </div>
        <div className="text-[#8B8D97] text-center my-7">
          <p>Mật khẩu của bạn đã được cập nhật thành công.</p>
          <p>Bảo mật tài khoản của bạn là ưu tiên hàng đầu của chúng tôi.</p>
        </div>
      </div>
    </Modal>
  );
}

export default ChangePasswordSuccessModal;
